import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../components/utils";

export const getOrderHistory = createAsyncThunk("orders/getOrderHistory", 
                                async (value, {getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const { userInfo } = auth;
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            }
        }
        const id = userInfo.id;
        const URL = BASE_URL;
        const { data } = await axios.get(`${URL}/api/orders/mine/${id}`, config);
        //dispatch({type: detailsOrder.fulfilled, payload: data});
        return data;
    } catch (err) {
        const message = err.response && err.response.data.message 
                        ? err.response.data.message
                        : err.message;
        //dispatch({type: detailsOrder.rejected, payload: message});
        return rejectWithValue(JSON.stringify(message));
    }
});
const initialState = {
    orders: [],
    error: "",
    status: null,
}
const orderHistorySlice = createSlice({
    name: "orderHistory",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(getOrderHistory.pending, (state, action) => {
            return { ...state, status: "pending" };
        });
        builder.addCase(getOrderHistory.fulfilled, (state, action) => {
            if(action.payload) {
                return {
                    ...state,
                    orders: action.payload,
                    status: "success"
                };
            } else {
                return state;
            }
        });
        builder.addCase(getOrderHistory.rejected, (state, action) => {
            return {
                ...state,
                status: "rejected",
                error: action.payload
            }
        });
    }
});

export default orderHistorySlice.reducer;